import axios from '../utils/axios';

export default function activateSeekerSubscriptions(adminId,data) {
    return (
        axios.post('/admin/' + adminId + '/manageSeekerSubscriptions/subscription/admin/activate-subscription?type=ea', data )
    )
}
